import { render } from "./BuildWeekGame.vue?vue&type=template&id=de725e60&scoped=true"
import script from "./BuildWeekGame.vue?vue&type=script&lang=js"
export * from "./BuildWeekGame.vue?vue&type=script&lang=js"

import "./BuildWeekGame.vue?vue&type=style&index=0&id=de725e60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de725e60"]])

export default __exports__